module.exports = __webpack_public_path__ + "static/media/netherlands.f163721e.svg";